module.exports = __webpack_public_path__ + "static/media/hair8.35b3bbfb.png";